var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIran2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iran@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-154.000000, -989.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Iran"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.000000, 919.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9,6.89 L0.9,15.89 L70.9,15.89 L70.9,6.89 C70.9,3.22282926 67.9271707,0.25 64.26,0.25 L7.55,0.25 C5.78723053,0.247345224 4.09575038,0.945742489 2.84834517,2.1912719 C1.60093997,3.43680131 0.899998001,5.12722853 0.9,6.89 Z",
    id: "Shape",
    fill: "#57A863"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "0.9 31.59 70.9 31.59 70.9 15.92 0.9 15.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9,40.61 C0.9,44.2771707 3.87282926,47.25 7.54,47.25 L64.26,47.25 C67.9271707,47.25 70.9,44.2771707 70.9,40.61 L70.9,31.61 L0.9,31.61 L0.9,40.61 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.81,23.37 L41.42,22.7 C41.2888282,22.4455608 41.2138048,22.1659279 41.2,21.88 L41.2,21.1 C41.1860695,20.8319192 41.0448496,20.5866425 40.82,20.44 L40.17,20.07 C39.9277557,19.9172501 39.7227499,19.7122443 39.57,19.47 L39.19,18.82 C39.0433575,18.5951504 38.7980808,18.4539305 38.53,18.44 L37.75,18.44 C37.4640721,18.4261952 37.1844392,18.3511718 36.93,18.22 L36.26,17.84 C36.0211524,17.7188438 35.7388476,17.7188438 35.5,17.84 L34.85,18.22 C34.5963844,18.3532887 34.3162746,18.4284401 34.03,18.44 L33.28,18.44 C33.0119192,18.4539305 32.7666425,18.5951504 32.62,18.82 L32.23,19.49 C32.0769859,19.7320332 31.8720332,19.9369859 31.63,20.09 L30.96,20.48 C30.7351504,20.6266425 30.5939305,20.8719192 30.58,21.14 L30.58,21.89 C30.5684401,22.1762746 30.4932887,22.4563844 30.36,22.71 L29.98,23.36 C29.8604385,23.5992265 29.8604385,23.8807735 29.98,24.12 L30.37,24.79 C30.5011718,25.0444392 30.5761952,25.3240721 30.59,25.61 L30.59,26.39 C30.6039305,26.6580808 30.7451504,26.9033575 30.97,27.05 L31.62,27.42 C31.8624577,27.5724826 32.0675174,27.7775423 32.22,28.02 L32.6,28.67 C32.7466425,28.8948496 32.9919192,29.0360695 33.26,29.05 L34.04,29.05 C34.3259279,29.0638048 34.6055608,29.1388282 34.86,29.27 L35.53,29.65 C35.7688476,29.7711562 36.0511524,29.7711562 36.29,29.65 L36.94,29.27 C37.1933671,29.1360774 37.4736232,29.0608867 37.76,29.05 L38.51,29.05 C38.7780808,29.0360695 39.0233575,28.8948496 39.17,28.67 L39.56,28 C39.7147831,27.7593873 39.9193873,27.5547831 40.16,27.4 L40.83,27.01 C41.0548496,26.8633575 41.1960695,26.6180808 41.21,26.35 L41.21,25.6 C41.2215599,25.3137254 41.2967113,25.0336156 41.43,24.78 L41.81,24.13 C41.9311562,23.8911524 41.9311562,23.6088476 41.81,23.37 Z M39.47,23.98 L39.24,24.37 C39.1599518,24.524898 39.1155358,24.6957288 39.11,24.87 L39.11,25.33 C39.1014805,25.4923741 39.0160469,25.6409542 38.88,25.73 L38.47,25.97 C38.3250297,26.0621202 38.2021202,26.1850297 38.11,26.33 L37.88,26.74 C37.7909542,26.8760469 37.6423741,26.9614805 37.48,26.97 L37,26.97 C36.8291287,26.9770018 36.6618696,27.0213767 36.51,27.1 L36.12,27.33 C35.9757697,27.4047207 35.8042303,27.4047207 35.66,27.33 L35.25,27.1 C35.0949818,27.020266 34.9242231,26.9758688 34.75,26.97 L34.28,26.97 C34.1176259,26.9614805 33.9690458,26.8760469 33.88,26.74 L33.65,26.35 C33.5578798,26.2050297 33.4349703,26.0821202 33.29,25.99 L32.91,25.76 C32.7739531,25.6709542 32.6885195,25.5223741 32.68,25.36 L32.68,24.89 C32.6723643,24.7192252 32.628025,24.5521001 32.55,24.4 L32.32,23.99 C32.246923,23.8453736 32.246923,23.6746264 32.32,23.53 L32.55,23.14 C32.630368,22.9852246 32.6748032,22.8143199 32.68,22.64 L32.68,22.19 C32.6885195,22.0276259 32.7739531,21.8790458 32.91,21.79 L33.32,21.55 C33.4649703,21.4578798 33.5878798,21.3349703 33.68,21.19 L33.91,20.78 C33.9990458,20.6439531 34.1476259,20.5585195 34.31,20.55 L34.77,20.55 C34.9408713,20.5429982 35.1081304,20.4986233 35.26,20.42 L35.65,20.19 C35.7946264,20.116923 35.9653736,20.116923 36.11,20.19 L36.52,20.42 C36.674898,20.5000482 36.8457288,20.5444642 37.02,20.55 L37.49,20.55 C37.6523741,20.5585195 37.8009542,20.6439531 37.89,20.78 L38.12,21.17 C38.2121202,21.3149703 38.3350297,21.4378798 38.48,21.53 L38.88,21.76 C39.0160469,21.8490458 39.1014805,21.9976259 39.11,22.16 L39.11,22.63 C39.1173216,22.8008227 39.1616784,22.968014 39.24,23.12 L39.47,23.53 C39.543077,23.6746264 39.543077,23.8453736 39.47,23.99 L39.47,23.98 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 2.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy",
    fill: "#FFFFFF",
    x: 6.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_2",
    fill: "#FFFFFF",
    x: 10.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_3",
    fill: "#FFFFFF",
    x: 14.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_4",
    fill: "#FFFFFF",
    x: 18.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_5",
    fill: "#FFFFFF",
    x: 22.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_6",
    fill: "#FFFFFF",
    x: 26.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7",
    fill: "#FFFFFF",
    x: 30.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-2",
    fill: "#FFFFFF",
    x: 34.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-3",
    fill: "#FFFFFF",
    x: 38.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-4",
    fill: "#FFFFFF",
    x: 42.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-5",
    fill: "#FFFFFF",
    x: 46.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-6",
    fill: "#FFFFFF",
    x: 50.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-7",
    fill: "#FFFFFF",
    x: 54.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_8",
    fill: "#FFFFFF",
    x: 58.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_8-2",
    fill: "#FFFFFF",
    x: 62.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_8-3",
    fill: "#FFFFFF",
    x: 66.9,
    y: 11.92,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 2.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy-2",
    fill: "#FFFFFF",
    x: 6.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_2-2",
    fill: "#FFFFFF",
    x: 10.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_3-2",
    fill: "#FFFFFF",
    x: 14.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_4-2",
    fill: "#FFFFFF",
    x: 18.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_5-2",
    fill: "#FFFFFF",
    x: 22.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_6-2",
    fill: "#FFFFFF",
    x: 26.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-2-2",
    fill: "#FFFFFF",
    x: 30.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-2-3",
    fill: "#FFFFFF",
    x: 34.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-3-2",
    fill: "#FFFFFF",
    x: 38.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-4-2",
    fill: "#FFFFFF",
    x: 42.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-5-2",
    fill: "#FFFFFF",
    x: 46.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-6-2",
    fill: "#FFFFFF",
    x: 50.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_7-7-2",
    fill: "#FFFFFF",
    x: 54.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_8-2-2",
    fill: "#FFFFFF",
    x: 58.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_8-2-3",
    fill: "#FFFFFF",
    x: 62.9,
    y: 33.57,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10_copy_8-3-2",
    fill: "#FFFFFF",
    x: 66.9,
    y: 33.57,
    width: 2,
    height: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran2X);
export default __webpack_public_path__ + "static/media/Iran@2x.be23649ee9dff7ca45b7048cd9358ef8.svg";
export { ForwardRef as ReactComponent };